import { render, staticRenderFns } from "./junction-box-fields-db.component.vue?vue&type=template&id=5c23ae6e"
import script from "./junction-box-fields-db.component.ts?vue&type=script&lang=ts&external"
export * from "./junction-box-fields-db.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c23ae6e')) {
      api.createRecord('5c23ae6e', component.options)
    } else {
      api.reload('5c23ae6e', component.options)
    }
    module.hot.accept("./junction-box-fields-db.component.vue?vue&type=template&id=5c23ae6e", function () {
      api.rerender('5c23ae6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin-panel/fields-db/junction-box-fields-db/junction-box-fields-db.component.vue"
export default component.exports